export const selectSettingsSpecificLocationHandler = (
  data,
  option,
  machineIndex,
  extraOption,
  locations,
  isSpecificLocationSelected,
  isMachineSelected,
  specificLocations,
  selectedSpecificLocations
) => {
  let index;
  specificLocations.forEach((el, i) => {
    if (el.includes(extraOption)) {
      index = i;
    }
  });

  const select = !isSpecificLocationSelected[index]?.[machineIndex];

  const isSpecificLocationNewArr = isSpecificLocationSelected[index]?.map(
    (_, idx) => (idx === machineIndex ? select : _)
  );
  const arr = [...isSpecificLocationSelected];
  arr[index] = isSpecificLocationNewArr;

  const locationIndex = locations.indexOf(option);
  const machineNewArr = isMachineSelected[locationIndex][machineIndex]?.map(
    () => select
  );

  const deepCopyArr = JSON.parse(JSON.stringify(isMachineSelected));
  deepCopyArr[locationIndex][machineIndex] = machineNewArr;

  let newSelect;
  if (select) {
    newSelect = [...selectedSpecificLocations];
    if (!newSelect.some((el) => el === extraOption)) {
      newSelect.push(extraOption);
    }
  } else {
    newSelect = selectedSpecificLocations.filter((el) => el !== extraOption);
  }

  return {
    specificLocationList: arr,
    machineList: deepCopyArr,
    newSpecificLocations: newSelect,
    select,
    locationIndex,
  };
};
